import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const tiers = [
  { name: "Saturday", price: "$349", note: "per cabana" },
  { name: "Sunday", price: "$249", note: "per cabana" },
  { name: "Friday", price: "$149", note: "per cabana" },
  { name: "Monday", price: "$149", note: "per cabana" },
  { name: "Tue / Wed / Thu", price: "$99", note: "lowest weekday rate" },
];

const CabanaPricingCards = () => {
  return (
    <section
      id="pricing"
      style={{ scrollMarginTop: "96px" }}
      className="scroll-mt-24 py-16 md:py-20"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">Cabana Pricing</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Weekdays as low as $99 — Saturdays $349, Sundays $249. One flat rate per
            private waterfront cabana, up to 8 guests included.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
          {tiers.map((t) => (
            <Card key={t.name} className="text-center border-border">
              <CardHeader>
                <CardTitle className="font-serif text-2xl text-foreground">{t.name}</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-4xl font-semibold text-primary">{t.price}</div>
                <div className="text-sm text-muted-foreground mt-1">{t.note}</div>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="text-center mt-8 text-foreground">
          <span className="font-medium">Add-on:</span> all-day tubing + kayak wristband{" "}
          <span className="font-semibold">$29.99</span> per person.
        </p>

        <p className="text-center mt-4 text-sm text-muted-foreground max-w-2xl mx-auto">
          Rates shown are average summer pricing. Spring and fall are typically lower, and holiday weekends run higher. Submit an inquiry for an exact quote on your dates.
        </p>

        <div className="text-center mt-8">
          <Button asChild size="lg">
            <Link to="/book-now">Check Availability</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CabanaPricingCards;